<template>
  <v-app-bar app color="white" elevation="2">
    <div class="d-flex align-center">
      <img alt="okboy logo" src="../assets/logo-okboy.png" @click="toHome()" />
    </div>

    <v-spacer></v-spacer>

    <div class="d-flex align-center justify-end">
      <v-btn class="buttonSecondary" @click="downloadApp()">Descarga la app</v-btn>
      <!-- <v-btn icon @click.stop="toDrawerNavigation()">
        <v-icon>mdi-menu</v-icon>
      </v-btn> -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="toSeguirServicio()">
            <v-list-item-title>Sigue tu servicio</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import precioCilindros from "../statics/cylinderGasPrice.json";
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  computed: {
    ...mapFields(["seguirServicioModal"]),
  },
  methods: {
    toSeguirServicio() {
      this.seguirServicioModal = true
    },
    toHome() {
      this.$router.push({ name: "Home" });
      location.reload()
    },
    downloadApp() {
      mixpanel.track('Click descarga app navigation');
      window.location = "http://okboy.app.link/ZRYV3YJZefb";
    },
  },
};
</script>

<style>
</style>